import React, { useState } from "react";
import CartoDAEAdmin from "./CartoDAEAdmin";
import CartoPatrimoineAdmin from "./CartoPatrimoineAdmin";
import CartoLieuxAdmin from "./CartoLieuxAdmin";
import CartoTracesAdmin from "./CartoTracesAdmin";
import CartoVoiriesAdmin from "./CartoVoiriesAdmin";

export default function OngletCartographie() {
  const [tab, setTab] = useState("dae");
  return (
    <div>
      <div className="admin-subtabs">
        <button className={tab === "dae" ? "active" : ""} onClick={() => setTab("dae")}>
          ❤ Défibrillateurs
        </button>
        <button className={tab === "patrimoine" ? "active" : ""} onClick={() => setTab("patrimoine")}>
          ⛪ Patrimoine
        </button>
        <button className={tab === "lieux" ? "active" : ""} onClick={() => setTab("lieux")}>
          🛒 Lieux & services
        </button>
        <button className={tab === "traces" ? "active" : ""} onClick={() => setTab("traces")}>
          🥾 Sentiers
        </button>
        <button className={tab === "voiries" ? "active" : ""} onClick={() => setTab("voiries")}>
          ❄ Voiries
        </button>
      </div>
      <div className="mt-2">
        {tab === "dae" && <CartoDAEAdmin />}
        {tab === "patrimoine" && <CartoPatrimoineAdmin />}
        {tab === "lieux" && <CartoLieuxAdmin />}
        {tab === "traces" && <CartoTracesAdmin />}
        {tab === "voiries" && <CartoVoiriesAdmin />}
      </div>
    </div>
  );
}
